<template>
  <v-container fluid class="page">
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined class="page-card">
          <div class="page-header">
            <div>
              <h2>Cambiar contrasena</h2>
              <p>Actualiza tu clave de acceso segura.</p>
            </div>
          </div>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="currentPassword"
              label="Contrasena actual"
              outlined
              dense
              :type="showCurrent ? 'text' : 'password'"
              :append-icon="showCurrent ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              @click:append="showCurrent = !showCurrent"
              :rules="requiredRules"
            />
            <v-text-field
              v-model="newPassword"
              label="Nueva contrasena"
              outlined
              dense
              :type="showNew ? 'text' : 'password'"
              :append-icon="showNew ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              @click:append="showNew = !showNew"
              :rules="requiredRules"
            />
            <v-btn
              color="primary"
              block
              class="page-btn"
              :loading="loading"
              :disabled="!valid || loading"
              @click="submit"
            >
              Actualizar clave
            </v-btn>
            <div v-if="success" class="success-text">Clave actualizada correctamente.</div>
            <div v-if="error" class="error-text">{{ error }}</div>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authService } from "../services/auth";

export default {
  name: "ChangePassword",
  data() {
    return {
      valid: false,
      currentPassword: "",
      newPassword: "",
      showCurrent: false,
      showNew: false,
      loading: false,
      error: "",
      success: false,
      requiredRules: [(v) => Boolean(v) || "Campo requerido"],
    };
  },
  methods: {
    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) return;
      this.error = "";
      this.success = false;
      this.loading = true;
      try {
        await authService.changePassword({
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        });
        this.success = true;
        this.currentPassword = "";
        this.newPassword = "";
      } catch (err) {
        this.error = "No pudimos actualizar la clave. Verifica los datos.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding: 0;
}

.page-card {
  border-radius: 18px;
  padding: 24px;
}

.page-header {
  margin-bottom: 18px;
}

.page-header h2 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
}

.page-header p {
  margin: 0;
  color: #64748b;
}

.page-btn {
  margin-top: 8px;
  height: 46px;
  font-weight: 700;
  text-transform: none;
}

.success-text {
  margin-top: 12px;
  color: #16a34a;
}

.error-text {
  margin-top: 12px;
  color: #dc2626;
}
</style>
